import { t_dataName } from 'src/app/services/apiHandler/basicMachineFunctions/basic-machine-functions.service';

export type t_BoomStickDataPoint = {
    generalName: string;
    dataName: t_dataName;
    unit: 'deg' | 'm' | '';
    value?: number;
};

export type t_BoomStickDataset = {
    dataPoints: t_BoomStickDataPoint[];
};

export var initBoomStickDataset: t_BoomStickDataset = {
    dataPoints: [
        {
            generalName: 'Boom-Angle',
            dataName: {
                name: 'BoomAngle',
            },
            unit: 'deg',
        },
        {
            generalName: 'Stick-Angle',
            dataName: {
                name: 'StickAngle',
            },
            unit: 'deg',
        },
        {
            generalName: 'Boom-Tip-X-Position',
            dataName: {
                name: 'BoomTipPosX',
            },
            unit: 'm',
        },
        {
            generalName: 'Boom-Tip-Y-Position',
            dataName: {
                name: 'BoomTipPosY',
            },
            unit: 'm',
        },
        {
            generalName: 'Stick-Tip-X-Position',
            dataName: {
                name: 'StickTipPosX',
            },
            unit: 'm',
        },
        {
            generalName: 'Stick-Tip-Y-Position',
            dataName: {
                name: 'StickTipPosY',
            },
            unit: 'm',
        },
        {
            generalName: 'Slew Angle',
            dataName: {
                name: 'SlewAngle',
            },
            unit: 'deg',
        },
        {
            generalName: 'KPS online',
            dataName: {
                name: 'KpsOnline',
            },
            unit: '',
        },
        {
            generalName: 'KPS System Calibrated',
            dataName: {
                name: 'KpsSystemCalibrated',
            },
            unit: '',
        },
    ],
};
